import { useEffect, useState } from 'react'
import { fabric } from 'fabric'

export const useCanvasActiveObject = (canvas?: fabric.Canvas | null) => {
  const [active, setActive] = useState<fabric.Object | null>(null)

  useEffect(() => {
    if (!canvas) return

    const update = () => setActive(canvas.getActiveObject() ?? null)

    update()
    canvas.on('selection:created', update)
    canvas.on('selection:updated', update)
    canvas.on('selection:cleared', update)
    canvas.on('object:modified', update)

    return () => {
      canvas.off('selection:created', update)
      canvas.off('selection:updated', update)
      canvas.off('selection:cleared', update)
      canvas.off('object:modified', update)
    }
  }, [canvas])

  return active
}